import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $SharingCurrentTraffic } from 'shared/atoms';
import { usePOICoverImage, usePOIDescription, usePOILinkPreviewTitle } from '@poi/shared/use-poi-tdk';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const POIOG: FC = () => {
  const { canonicalUrl } = useAtomValue($SharingCurrentTraffic);
  const title = usePOILinkPreviewTitle();
  const description = usePOIDescription();
  const cover = usePOICoverImage();

  return (
    <DynamicHead>
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {cover && (
        <DynamicHead>
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image" content={cover.url} />
          <meta property="og:image:width" content={`${cover.width}`} />
          <meta property="og:image:height" content={`${cover.height}`} />
        </DynamicHead>
      )}
    </DynamicHead>
  );
};
